import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../Entity'
import {
  getIsViewingOpenSlot,
  getListingViewingTimeRangeLabel,
  RentalPortalViewingDateCell,
} from '../../../../RentalPortalViewing'
import { TableCellBase, TableEmptyCell, TableTextCell } from '../../../../Table'
import { ApplicantViewingColumnName } from '../RentalPortalApplicantProfileViewings.constants'
import { getApplicantViewingListingLabel } from '../RentalPortalApplicantProfileViewings.utils'

export function renderApplicantProfileViewingsCell({
  item,
  locale,
  name,
  t,
  timezone,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case ApplicantViewingColumnName.DateTime:
      return value ? (
        <RentalPortalViewingDateCell
          {...restProps}
          isFreeSlot={getIsViewingOpenSlot(item)}
          locale={locale}
          start={value}
          timeLabel={getListingViewingTimeRangeLabel({
            end: item.end,
            locale,
            start: item.start,
            timezone,
          })}
          timezone={timezone}
        />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case ApplicantViewingColumnName.Listing:
      return (
        <TableTextCell
          {...restProps}
          value={getApplicantViewingListingLabel({ item, t })}
        />
      )

    case ApplicantViewingColumnName.Status:
      return RENTAL_PORTAL_VIEWING_STATUSES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={RENTAL_PORTAL_VIEWING_STATUSES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    default:
      return <TableEmptyCell {...restProps} />
  }
}
